import { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import clienteAxios from "../../helpers/axios.helper";
import Swal from "sweetalert2";

function TablaServicios() {
  const [servicios, setServicios] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 15;
  const navigate = useNavigate();
  const fetchServicios = async () => {
    try {
      const response = await clienteAxios.get("/servicios");
      setServicios(response.data);
    } catch (error) {
      console.error("Error al cargar los servicios:", error);
    }
  };
  // Cargar servicios desde la base de datos
  useEffect(() => {
    fetchServicios();
  }, []);

  const offset = currentPage * itemsPerPage;
  const currentItems = servicios.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(servicios.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  // Manejar eliminación de servicios
  const eliminarServicio = async (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás deshacer esta acción.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await clienteAxios.delete(`/servicios/${id}`);
          Swal.fire("Eliminado", "El servicio ha sido eliminado con éxito.", "success");
          fetchServicios();
        } catch (error) {
          console.error("Error al eliminar el servicio:", error);
          Swal.fire("Error", "No se pudo eliminar el servicio.", "error");
        }
      }
    });
  };

  const handleEditar = (servicio) => {
    navigate("/formulario-servicio", { state: { servicio, modoEdicion: true } });
  };

  return (
    <div className="bg-white p-4 rounded-lg border-2 border-GrisOscuro">
      {/* Botón para agregar */}
      <div className="flex justify-end mb-4">
        <button
          className="py-2 px-4 bg-Verde text-Blanco font-semibold rounded hover:bg-green-600"
          onClick={() => navigate("/formulario-servicio")}
        >
          Agregar Servicio
        </button>
      </div>

      {/* Tabla */}
      <table className="min-w-full bg-white border">
        <thead>
          <tr>
            <th className="text-start py-2 px-4 border-b">Nombre</th>
            <th className="text-start py-2 px-4 border-b">Descripción</th>
            <th className="text-start py-2 px-4 border-b">Precio</th>
            <th className="text-start py-2 px-4 border-b">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((servicio) => (
            <tr key={servicio.Id}>
              <td className="py-2 px-4 border-b">{servicio.nombre}</td>
              <td className="py-2 px-4 border-b">{servicio.descripcion}</td>
              <td className="py-2 px-4 border-b">AR${servicio.preciopeso}</td>
              <td className="py-2 px-4 border-b">
                <div className="flex space-x-2">
                  <button
                    className="px-3 py-1 bg-Amarillo text-Blanco rounded border hover:bg-Blanco hover:text-Negro hover:border-Amarillo"
                    onClick={() => handleEditar(servicio)}
                  >
                    Editar
                  </button>
                  <button
                    className="px-3 py-1 bg-Rojo text-Blanco rounded border hover:bg-Blanco hover:text-Negro hover:border-Rojo"
                    onClick={() => eliminarServicio(servicio.id)}
                  >
                    Eliminar
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Paginación */}
      <div className="flex w-full flex-row h-20 justify-center items-end">
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          containerClassName="flex justify-center items-center"
          pageClassName="p-1 px-3 text-Negro bg-GrisClaro"
          activeClassName="bg-GrisOscuro text-Blanco"
          previousClassName="px-2 py-1 text-Rojo font-bold text-xl"
          nextClassName="px-2 py-1 text-Rojo font-bold text-xl"
          breakClassName="px-2 py-1 text-Rojo"
        />
      </div>
    </div>
  );
}

export default TablaServicios;
